import React, { Component } from 'react';
import Constants from '../../../../../definitions/constants';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../../tooling/javascriptUtilsTooling';
import InterfaceTooling from '../../../../../tooling/interfaceTooling';
import toastr from 'toastr';

import Select from '../../../common/inputs/select';
import TextBox from '../../../common/inputs/textBox';
import FetchAutocompleteSelect from '../../../common/inputs/fetchAutocompleteSelect';

const initialObjectState = {
  type: "",
  value: ""
}

class InMetricFakeFunctionParamsEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState),      
      toEditObjectPosition: null,   
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    };
  } 

  componentDidMount() {
    this.props.escBehaviourHandler(false);
  }

  componentWillUnmount = () => {
    this.props.escBehaviourHandler(false); 
  }
  
  componentDidUpdate(prevProps, prevState) {
    if(!prevState.showOverlay && this.state.showOverlay) {
      InterfaceTooling.bringObjectEditorInputIntoView();
    }
  }
  
  isValidObject = (object) => {
    if(object.type == ""  || (object.value == "" && object.type!=Constants.selectKeys.formulaEditor.inMetricParamTypes.FREE)) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.polynomialDimensionsError"}),"");
      return false;
    }
    return true;
  };
    
  handleAddButtonClick = (event) => {
    if(this.editItemInput) {
      this.editItemInput.focus();
    }
  };

  handleCancelAdd = (event) => {
    this.setState({
      showOverlay: false,
      toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
    this.props.escBehaviourHandler(false);
  };

  handleChangeAddItem = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toAddObject = JavascriptUtilsTooling.deepCopy(this.state.toAddObject);
    toAddObject[event.currentTarget.dataset.path] = value;
    if(event.currentTarget.dataset.path=="type") {
      toAddObject.value = "";
    }
    this.setState({
      showOverlay: true,
      toAddObject: toAddObject
    });
    this.props.escBehaviourHandler(true);    
  };

  handleOnEnterAddItem = (event) => {
    if(this.addItemSaveButton) {
      this.addItemSaveButton.click();
    }  
  };

  handleSaveAddItem = (event) => {
    if(this.isValidObject(this.state.toAddObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toAddObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });
    }
    this.props.escBehaviourHandler(false);
  };

  handleClickEdit = (event) => {
    let itemIndex = event.currentTarget.dataset.index;    
    let objectToEdit = JSON.parse(event.currentTarget.dataset.value);
    this.setState({
      showOverlay: true,
      toEditObjectPosition: itemIndex,
      toEditObject: objectToEdit
    });
    this.props.escBehaviourHandler(true);
  };

  handleChangeEdit = (event) => {
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    var toEditObject = JavascriptUtilsTooling.deepCopy(this.state.toEditObject);
    toEditObject[event.currentTarget.dataset.path] = value;
    if(event.currentTarget.dataset.path=="type") {
      toEditObject.value = "";
    }
    this.setState({
      toEditObject: toEditObject
    });  
  };

  handleCancelEdit = (event) => {
    this.setState({
      showOverlay: false,
      toEditObjectPosition: null,
      toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
    });
    this.props.escBehaviourHandler(false);
  };

  handleSaveEditItem = (event) => {
    if(this.isValidObject(this.state.toEditObject)) {
      this.props.onChange(event);
      this.setState({
        showOverlay: false,
        toEditObjectPosition: null,
        toEditObject: JavascriptUtilsTooling.deepCopy(initialObjectState)
      });   
      this.props.escBehaviourHandler(false);
    }     
  };

  handleOnEnterEditItem = (event) => {
    if(this.editItemSaveButton) {
      this.editItemSaveButton.click();      
    }   
  };

  render() {
    const {
      className,
      dimensionId,
      dimensionList,
      dimensionOptions,
      typeOptions,
      dimensionInstancesOptions,
      dimensionInstancesFetch,
      dimensionInstancesLoading,
      values,
      onChange,
      handleGoToEditFormula,
      disabled,
      escBehaviourHandler,
    } = this.props;
    const dataPath = this.props["data-path"];
    return (
      <div className={"custom-input free-text-list select-list object-editor formula-dimensions-param-editor" + (className ? " " + className : "") + " select-list-no-search" + (this.state.showOverlay ? " free-text-list-overlay" : "")}>
        {this.state.showOverlay && (<div className="free-text-list-overlay-item"></div>)}
        <div className="free-text-list-label">
          <FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.functionLabel"/>
          {(!disabled) && (<i className="fas fa-plus-circle" onClick={this.handleAddButtonClick}/>)}
        </div>
          <div className="free-text-list-list-wrapper">
            {values && values.map((item,i) => {
              if(this.state.toEditObjectPosition == i) {
                return (
                  <div key={i} className="free-text-list-list-item free-text-list-list-item-edit">
                    <div className="free-text-list-list-item-inner object-editor-inputs">
                      <div className="object-editor-inputs-linebreak"> 
                        <Select 
                          className="free-text-list-list-add-item formula-dimensions-param-editor-type"
                          value={this.state.toEditObject.type}
                          labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.typeLabel"/>}
                          options={typeOptions ? typeOptions : []}
                          onChange={this.handleChangeEdit}
                          data-path={"type"}
                        />
                        {(this.state.toEditObject.type == Constants.selectKeys.formulaEditor.inMetricParamTypes.STRING && 
                          dimensionId &&
                          dimensionList.find(dimensionItem => dimensionItem.id==dimensionId).domain_input_source == Constants.selectKeys.dimension.domain_input_source.DEF_USER) ? (
                          <FetchAutocompleteSelect
                            className="free-text-list-list-add-item formula-dimensions-param-editor-value"
                            data-path={"value"}
                            data-searchdata={dimensionId}
                            value={this.state.toEditObject.value}
                            onChange={this.handleChangeEdit}
                            labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueLabel"/>}
                            options={dimensionInstancesOptions ? InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionInstancesOptions, "value", "value", false) : []}
                            valueAccesor={"value"}
                            labelAccesor={"value"}
                            minSearchLength={0}
                            nonObjectValue={true}
                            fetchListAction={dimensionInstancesFetch}
                            loadingFetch={dimensionInstancesLoading}
                          />
                        ) : (this.state.toEditObject.type == Constants.selectKeys.formulaEditor.inMetricParamTypes.STRING) ? (
                          <TextBox
                            className="free-text-list-list-edit-item formula-dimensions-param-editor-value"
                            styleType={Constants.interface.inputs.styleType.OUTLINED}
                            onChange={this.handleChangeEdit}
                            data-path={"value"}
                            value={this.state.toEditObject.value}
                            onKeyEnter={this.handleOnEnterEditItem}
                            type={Constants.interface.inputs.type.TEXT}
                            labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueLabel"/>}
                          />
                        ) : (this.state.toEditObject.type == Constants.selectKeys.formulaEditor.inMetricParamTypes.CONTEXT_DIMENSION) ? (
                          <Select 
                            className="free-text-list-list-add-item formula-dimensions-param-editor-value"
                            value={this.state.toEditObject.value}
                            labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueDimensionLabel"/>}
                            options={dimensionOptions ? dimensionOptions : []}
                            onChange={this.handleChangeEdit}
                            data-path={"value"}
                          />
                        ) : (null)}
                      </div>
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-edit">
                        <i 
                          ref={(input) => { this.editItemSaveButton = input; }}
                          className="fas fa-save"
                          data-index={i}                        
                          data-value={JSON.stringify(this.state.toEditObject)}
                          data-functionparameditor={"true"}
                          data-path={dataPath}
                          data-edit={"true"}
                          onClick={this.handleSaveEditItem}                      
                        />         
                        <i className="fas cancel-action fa-times-circle" onClick={this.handleCancelEdit}/>
                      </div>
                    )}
                  </div>
                );
              }
              else {
                let itemInnerText = intl.formatMessage({ id: "polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues."+item.type}) + ": ";
                if(item.type!=Constants.selectKeys.formulaEditor.inMetricParamTypes.FREE) {
                  itemInnerText += item.value;
                }
                return (
                  <div key={i} className="free-text-list-list-item">
                    <div title={itemInnerText} className="free-text-list-list-item-inner">
                      {itemInnerText}
                      {(item.type==Constants.selectKeys.formulaEditor.inMetricParamTypes.FREE) && (
                        <span data-paramindex={i} className="simulated-a" onClick={handleGoToEditFormula}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.goToEditFormula"/></span>
                      )}
                    </div>
                    {!disabled && (
                      <div className="free-text-list-list-item-action-buttons">
                        <i 
                          className="fas fa-edit"
                          onClick={this.handleClickEdit}
                          data-index={i}
                          data-value={JSON.stringify(item)}
                        />
                        <i
                          className="fas delete-action fa-trash"                          
                          data-index={i}
                          data-delete={"true"}
                          data-functionparameditor={"true"}
                          data-value={JSON.stringify(item)}
                          data-path={dataPath}
                          onClick={onChange}
                        />
                      </div>
                    )}
                  </div>
                );
              }
            })}
            <div className="free-text-list-list-item free-text-list-list-item-add">
              <div className="free-text-list-list-item-inner">
                {!disabled && (
                  <div className="object-editor-inputs">
                    <div className="object-editor-inputs-linebreak"> 
                      <Select 
                        className="free-text-list-list-add-item formula-dimensions-param-editor-type"
                        value={this.state.toAddObject.type}
                        labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.typeLabel"/>}
                        options={typeOptions ? typeOptions : []}
                        onChange={this.handleChangeAddItem}
                        data-path={"type"}
                        ref={(input) => { this.editItemInput = input; }}
                      />
                      {(this.state.toAddObject.type == Constants.selectKeys.formulaEditor.inMetricParamTypes.STRING && 
                          dimensionId &&
                          dimensionList.find(dimensionItem => dimensionItem.id==dimensionId).domain_input_source == Constants.selectKeys.dimension.domain_input_source.DEF_USER) ? (
                          <FetchAutocompleteSelect
                            className="free-text-list-list-add-item formula-dimensions-param-editor-value"
                            data-path={"value"}
                            data-searchdata={dimensionId}
                            value={this.state.toAddObject.value}
                            onChange={this.handleChangeAddItem}
                            labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueLabel"/>}
                            options={dimensionInstancesOptions ? InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionInstancesOptions, "value", "value", false) : []}
                            valueAccesor={"value"}
                            labelAccesor={"value"}
                            minSearchLength={0}
                            nonObjectValue={true}
                            fetchListAction={dimensionInstancesFetch}
                            loadingFetch={dimensionInstancesLoading}
                          />
                        ) : (this.state.toAddObject.type == Constants.selectKeys.formulaEditor.inMetricParamTypes.STRING) ? (
                        <TextBox
                          className="free-text-list-list-edit-item formula-dimensions-param-editor-value"
                          styleType={Constants.interface.inputs.styleType.OUTLINED}
                          onChange={this.handleChangeAddItem}
                          data-path={"value"}
                          value={this.state.toAddObject.value}
                          onKeyEnter={this.handleOnEnterAddItem}
                          type={Constants.interface.inputs.type.TEXT}
                          labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueLabel"/>}
                        />
                      ) : (this.state.toAddObject.type == Constants.selectKeys.formulaEditor.inMetricParamTypes.CONTEXT_DIMENSION) ? (
                        <Select 
                          className="free-text-list-list-add-item formula-dimensions-param-editor-value"
                          value={this.state.toAddObject.value}
                          labelLocale={<FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.valueDimensionLabel"/>}
                          options={dimensionOptions ? dimensionOptions : []}
                          onChange={this.handleChangeAddItem}
                          data-path={"value"}
                        />
                      ) : (null)}
                    </div>
                  </div>
                )}
              </div>
              {!disabled && (
                <div className="free-text-list-list-item-action-buttons free-text-list-list-item-action-buttons-add">
                  <i 
                    ref={(input) => { this.addItemSaveButton = input; }}
                    className="fas fa-save"
                    data-functionparameditor={"true"}
                    data-value={JSON.stringify(this.state.toAddObject)}
                    data-path={dataPath}
                    onClick={this.handleSaveAddItem}   
                  />
                  <i 
                    className="fas cancel-action fa-times-circle"
                    onClick={this.handleCancelAdd}
                  />
                </div>
              )}
            </div>
          </div>
      </div>
    );
  }
}

export default InMetricFakeFunctionParamsEditor;




// WEBPACK FOOTER //
// ./source/client/components/formulaEditor/entityEditors/objectInputs/inMetricFakeFunctionParamsEditor.jsx